// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dropdown_dropdown__QEFz6 {
  margin: 1rem 0;
}

.Dropdown_label__JVqvE {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: var(--color-text);
}

.Dropdown_select__g2uCn {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: 4px;
  background-color: var(--color-bg-alt);
  color: var(--color-text);
}
`, "",{"version":3,"sources":["webpack://./src/components/Dropdown/Dropdown.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;EACrC,wBAAwB;AAC1B","sourcesContent":[".dropdown {\n  margin: 1rem 0;\n}\n\n.label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n  color: var(--color-text);\n}\n\n.select {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: 4px;\n  background-color: var(--color-bg-alt);\n  color: var(--color-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `Dropdown_dropdown__QEFz6`,
	"label": `Dropdown_label__JVqvE`,
	"select": `Dropdown_select__g2uCn`
};
export default ___CSS_LOADER_EXPORT___;
